// extracted by mini-css-extract-plugin
export default {"fade":"_2Egs1xeY","fadein":"_2Zl883pc"};